import { render, staticRenderFns } from "./Invoice-customers.vue?vue&type=template&id=38d8d9c7"
import script from "./Invoice-customers.vue?vue&type=script&lang=js"
export * from "./Invoice-customers.vue?vue&type=script&lang=js"
import style0 from "./Invoice-customers.vue?vue&type=style&index=0&id=38d8d9c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports